import { useTheme } from '@mui/material';
const useHistoryDetailStyles = () => {
    const theme = useTheme();
    const headerHeight = '48px';
    const bottomNavigationHeight = '56px';
    return {
        incidentDetailSectionStyles: {
            display: 'flex',
            flexDirection: 'column !important',
            p: 2,
            height: `calc(100dvh - ${headerHeight} - ${bottomNavigationHeight})`,
            overflowY: 'auto'
        },
        locationContainerStyles: {
            display: 'flex',
            justifyContent: 'space-between',
            pt: 2,
            pb: 1
        },
        viewMapStyles: {
            color: theme.palette.info.dark
        },
        locationLeftSectionStyles: {
            flex: 1
        },
        mediaContainerStyles: {
            mt: '20px'
        }
    };
};
export default useHistoryDetailStyles;
